module.exports = __webpack_public_path__ + "img/C.156e525b.png";